import { TableCell, TableRow } from '@cobliteam/ui/components/Table';
import { type Cell, flexRender, type Row } from '@tanstack/react-table';
import { useMemo } from 'react';
import { getCommonPinningStyles } from '../utils';

interface RenderRowsProps<TData> {
  index: number;
  row: Row<TData>;
  selected?: boolean;
  virtualizer?: any;
}

const DataTableCell = <TData,>({ column, id, getContext }: Cell<TData, unknown>) => {
  const style = useMemo(() => getCommonPinningStyles(column), [column, column.getIsPinned()]);

  return (
    <TableCell key={id} style={style} className='!px-4 overflow-hidden text-ellipsis'>
      {flexRender(column.columnDef?.cell, getContext())}
    </TableCell>
  );
};

const DataTableRow = <TData,>({ index, row, selected, virtualizer }: RenderRowsProps<TData>) => {
  const estimatedSize = virtualizer?.options.estimateSize();

  // Since table uses content-based layout, the height below act as a minimum height.
  const style = virtualizer ? { transform: 'translateY(var(--first-start))', ...(estimatedSize ? { height: `${estimatedSize}px` } : {}) } : {};

  const isEven = index % 2 === 0;

  const visibleCells = row.getVisibleCells();
  const cells = useMemo(() => visibleCells.map((cell) => <DataTableCell key={cell.id} {...cell} />), [visibleCells, selected]);

  return (
    <TableRow ref={virtualizer?.measureElement} className='border-gray-4 border-b' key={index} hover data-index={index} data-state={selected} isEven={isEven} style={style}>
      {cells}
    </TableRow>
  );
};

export default DataTableRow;
